<template>
  <form @submit.stop.prevent="handleSubmit">
    <supplies-infocard-form 
      :infocard="supplies" 
      @submittable-status-changed="handleSubmittableStatusChanged"
    />
  </form>
</template>

<script>
import SuppliesInfocardForm from "@/app/views/background-data/infocards/components/SuppliesInfocardForm.vue";
import { mapActions } from "vuex";

export default {
  props: {
    location: {
      require: false,
    },
    infoCard: {
      required: false,
    },
    resourceId: {
      required: true,
    },
    name: {
      default: undefined,
    },
  },
  components: {
    SuppliesInfocardForm,
  },
  mounted() {
    if (this.location) {
      this.supplies.locationId = this.location.id;
      this.supplies.longitude = this.location.longitude;
      this.supplies.latitude = this.location.latitude;
    }
    if (this.infoCard) {
      this.isCreate = false;
      this.supplies = { ...this.infoCard };
    }
    if (this.name) {
      this.supplies.name = this.name;
    }
  },
  data() {
    return {
      isCreate: true,
      supplies: {
        type: "SuppliesInfocard",
        id: this.resourceId,
        name: undefined,
        coverPath: undefined,
        longitude: 0,
        latitude: 0,
        locationId: undefined,
        collectorId: undefined,
        internalGroupId: undefined,
        supplierIdRefNumber: [],
        price: 0,
        note: undefined,
        quantity: 1,
      },
    };
  },
  methods: {
    ...mapActions({
      createInfoCard: "infoCards/create",
      updateInfoCard: "infoCards/update",
    }),
    handleSubmittableStatusChanged(canSubmit) {
      this.$emit("can-submit-status-changed", canSubmit);
    },
    async submit() {
      if (this.isCreate) {
        await this.createInfoCard({
          data: this.supplies,
          resourceId: this.resourceId,
        });
      } else {
        await this.updateInfoCard({ data: this.supplies });
      }
    },
  },
};
</script>